import React, {useEffect} from 'react';
import 'react-h5-audio-player/lib/styles.css';
import 'video-react/dist/video-react.css';
import QuestionFactor from "./QuestionFactor";
import {nextAbleQuestionsState} from "../../../../states/test_progress_states";
import withQuestionLogic from "../../../HOC/withQuestionLogic";
import {useRecoilValue} from "recoil/dist";

const GroupQuestion = (props) => {
    const {question, index, selectAnswer, markNextAble} = props;
    const nextAbleQuestions = useRecoilValue(nextAbleQuestionsState);

    //questionGroup được next nếu tất cả các sub-question được next
    useEffect(() => {
        //nếu chưa next được ==> kiểm tra các sub-question đã next được chưa?
        let nextAble = true;
        question.questions.forEach(subQuestion => {
            //Do questionType NA không cần click nên dễ bị conflict lúc init khi đề có nhiều câu NA
            if (subQuestion.questionType !== "NA" && nextAbleQuestions.includes(subQuestion.questionCode) === false)
                nextAble = false;
        });

        if (nextAbleQuestions.includes(question.questionCode) !== nextAble)
        {
            markNextAble(nextAble)
        }
    }, [nextAbleQuestions]);

    return (
        <React.Fragment>
            {
                question.questions.map((question, key) => {
                    return (
                        <div key={key} className="group-question" style={{padding: 15}}>
                            <QuestionFactor question={question} index={index + "." + (key + 1)}
                                            selectAnswer={selectAnswer}/>
                        </div>
                    )
                })
            }
        </React.Fragment>

    );
};

export default withQuestionLogic(GroupQuestion);
